import State from '../core/State';
import initialState from '../initialState';
import produce, { Draft } from 'immer';
import { Chart } from '@kaizenplatform/kaizen-chartjs';

export const startFetchingLiftUpReport = () =>
  produce((draft: Draft<State>) => {
    draft.liftUpReportChart.fetching = draft.liftUpReportChart.fetching + 1;
  });

export const setLiftUpReport = (liftUpReportChart: Chart | Chart[]) =>
  produce((draft: Draft<State>) => {
    draft.liftUpReportChart.data = liftUpReportChart;
  });

export const finishFetchingLiftUpReport = () =>
  produce((draft: Draft<State>) => {
    draft.liftUpReportChart.fetching = draft.liftUpReportChart.fetching - 1;
  });

export const disposeLiftUpReport = () =>
  produce((draft: Draft<State>) => {
    draft.liftUpReportChart.data = initialState.liftUpReportChart.data;
    draft.liftUpReportChart.fetching = initialState.liftUpReportChart.fetching;
  });
